export default "__VITE_ASSET__CBYaRBP9__"